module.exports = __webpack_public_path__ + "img/alloy@2x.c46622e.webp";